import React from 'react';

import AssetManager from '@components/workbench/individual/asset_manager/main';
import Controls from '@components/workbench/individual/tags/controls';

class Tags extends React.Component {
  render() {
    return (
      <AssetManager extractTags>
        <Controls />
      </AssetManager>
    );
  }
}

export default Tags;
